<template>
  <table class="table is-fullwidth is-hoverable is-striped">
    <thead>
    <tr>
      <th></th>
      <th>Carrier name</th>
      <th v-for="doc in documentList" :key="doc.fieldName"> {{ doc.displayName }} </th>
    </tr>
    <tr>
      <th></th>
      <th>
        <b-input type="text" v-model="filterCarrierName" placeholder="Filter carrier" />
      </th>
      <th v-for="doc in documentList" :key="doc.fieldName"> &nbsp; </th>
    </tr>
    </thead>

    <tbody>
    <tr v-for="data in filteredList"
        :carrierDetails="data"
        @uploaded="fetchCarriers"
        is='table-row'
        :key="data.accountKey" ></tr>
    </tbody>
  </table>
</template>

<script>
import CarriersApi from '@/api-interface/carriers'
import TableRow from './row'
import CarrierFileUploads from '@/lookup-data/carrier-file-uploads'
import { sortBy } from 'lodash-es'

export default {
  name: 'CarrierDocumentUpload',

  data() {
    return {
      documentList: CarrierFileUploads,
      carriers: [],
      filterCarrierName: ''
    }
  },

  components: {
    TableRow
  },

  created() {
    this.fetchCarriers()
  },

  computed: {
    sortedList() {
      return sortBy(this.carriers, 'accountFirstName')
    },
    filteredList() {
      const filter = this.filterCarrierName.toLocaleLowerCase()
      return this.sortedList.filter((carrier) => {
        return (
          carrier.accountFirstName.toLocaleLowerCase().includes(filter) ||
          carrier.accountLastName.toLocaleLowerCase().includes(filter) ||
          carrier.accountEmailAddress.toLocaleLowerCase().includes(filter)
        )
      })
    }
  },

  methods: {
    async fetchCarriers() {
      this.carriers = await CarriersApi.list({ hasMissingDocuments: true })
    }
  }
}
</script>

<style scoped>
</style>
